"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  > * {\n    margin: 1px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiAvatar = void 0;

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

function MultiAvatar(_ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size;
  return react_1.default.createElement(Container, {
    style: {
      width: size,
      height: size,
      padding: size / 8
    }
  }, react_1.default.Children.map(children, function (child, index) {
    if (index > 3) return null;
    return react_1.default.cloneElement(child, {
      size: size / 3,
      key: index
    });
  }));
}

exports.MultiAvatar = MultiAvatar;
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@gray-2'];
});